<template>
  <sub-page title="我的文书">
    <div class="doc-page">
      <!-- 标签栏 -->
      <div class="tab-bar">
        <div
          v-for="tab in tabs"
          :key="tab.key"
          class="tab-item"
          :class="{ active: activeTab === tab.key }"
          @click="activeTab = tab.key"
        >{{ tab.label }}</div>
      </div>

      <!-- 空状态 -->
      <div class="empty-state">
        <img :src="emptyImg" class="empty-img" alt="empty" />
        <div class="empty-text">暂无{{ activeLabel }}数据</div>
      </div>
    </div>
  </sub-page>
</template>

<script>
import SubPage from './SubPage.vue'

export default {
  name: 'MyDoc',
  components: { SubPage },
  data() {
    return {
      activeTab: 'pending',
      tabs: [
        { key: 'pending', label: '待签收' },
        { key: 'delivered', label: '已送达' }
      ],
      emptyImg: require('@/assets/icons/empty.png')
    }
  },
  computed: {
    activeLabel() {
      const tab = this.tabs.find(t => t.key === this.activeTab)
      return tab ? tab.label : ''
    }
  }
}
</script>

<style scoped>
.doc-page {
  background: #F3F8FB;
  min-height: 100%;
}
.tab-bar {
  display: flex;
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
}
.tab-item {
  flex: 1;
  text-align: center;
  height: calc(96 * var(--w));
  line-height: calc(96 * var(--w));
  font-size: calc(28 * var(--w));
  color: #969799;
  position: relative;
  cursor: pointer;
  transition: color 0.2s;
}
.tab-item.active {
  color: #2E8CF6;
  font-weight: 600;
}
.tab-item.active::after {
  content: '';
  position: absolute;
  bottom: calc(8 * var(--w));
  left: 50%;
  transform: translateX(-50%);
  width: calc(48 * var(--w));
  height: calc(6 * var(--w));
  background: linear-gradient(90deg, #2E8CF6, #5EA9FA);
  border-radius: calc(3 * var(--w));
}
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: calc(200 * var(--w));
}
.empty-img {
  width: calc(240 * var(--w));
  height: calc(240 * var(--w));
  object-fit: contain;
  opacity: 0.9;
}
.empty-text {
  margin-top: calc(24 * var(--w));
  font-size: calc(30 * var(--w));
  color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/pages/MyDoc.vue